import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/device/browser_/connect')({
  component: () => (
    <Navigate to="/device/browser" replace search={{ showOtp: true }} />
  ),
});
